<template>
  <div class="form-columns">
    <div class="form-side-text">je hebt de link gebruikt om je wachtwoord te wijzigen. 
        voer hier tweemaal hetzelfde, nieuwe wachtwoord in dat je wilt gebruiken.
    </div>

    <div class="form-container">
      <div class="header">
        <div class="closeButton">
          <button class="w3-button w3-right theme-icon-button" @click="home">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <h3>wachtwoord reset</h3>
      </div>
      
      <div class="fieldsContainer">
        <div class="input">
          <div style="flex: 1;"><input v-model="passwordInput" @change="onChange" v-on:keyup.enter="signUp" class="themeInput" type="password" :placeholder="$t('signin.password')"></div>
          <div><font-awesome-icon icon="lock" class="inputImage"/></div>
        </div>
        <div class="validation">
            <font-awesome-icon v-if="passwordLengthOk" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.eightCharacters')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasNumber" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsNumber')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasUpperCase" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsCapital')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasLowerCase" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsLowercase')}}
        </div>

        <div class="input">
            <div style="flex: 1;"><input v-model="passwordInputCheck" v-on:keyup.enter="confirm" class="theme-input" type="password" placeholder="wachtwoord verificatie"></div>
            <div><font-awesome-icon icon="lock" class="inputImage"/></div>
        </div>        

        <div class="validation">
            <font-awesome-icon v-if="passwordsAreEqual" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.passwordsEqual')}}
        </div>
      </div>

      <section class="buttons">
        <button class="button-default" @click="resend">versturen</button>
      </section>
    </div>

    <div class="dummy-space">&nbsp;</div>
    <router-link to="/" class="bottomLogo"><img src="../../assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"> Chess Administrator</router-link>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/Authentication/ChangePassword';

export default {
  name: 'ResetPassword',
  data: function () {
    return {
      passwordInput: "",
      passwordInputCheck: "",
      codeInput: "",
      errorMessage: ""
    }
  },
  computed: {
    passwordsAreEqual() {
      return (this.passwordInput.length > 0) && (this.passwordInput == this.passwordInputCheck);
    },
    passwordLengthOk() {
      return this.passwordInput.length >= 8;
    },
    passwordHasNumber() {
      return /\d/.test(this.passwordInput);
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.passwordInput);
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.passwordInput);
    }
  },
  methods: {
    resend() {
      let that = this;
      const myInit = { 
        body: {
          Token: this.$route.query.token,
          Email: this.$route.query.email,
          Password: this.passwordInput,
          PasswordCheck: this.passwordInputCheck
        },
        response: false, 
      };

      console.log("Body:" + JSON.stringify(myInit));

      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log("Password successfully changed." + JSON.stringify(response));
          that.$router.push("/sign-in?ontheside=passwordResetMessage");
        })
        .catch(error => {
          console.log("Data: " + JSON.stringify(error.response.data));
          console.log("Error: " + JSON.stringify(error.response));
        });
    },
    home() {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.errorIcon {
  margin-top: 4px; 
}

.fieldsContainer {
  width: 100%;
  box-sizing: border-box;
}

/* mobile */
@media screen and (max-width: 600px) {
  .fieldsContainer {
    width: 100%;
    padding: 0;
  }

  .validation {
    margin-left: 2vw;
    font-size: 0.9em;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .fieldsContainer {
    width: 100%;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .fieldsContainer {
    width: 100%;
  }
}

</style>
